/**
 * The property can be assigned by the declaring entity.
 * Entities that extend it can add additional values to the property (values are additive).
 */
export const referencablePropType_Inherit = 'inherit';
/**
 * The declaring entity cannot assign any value to the property. It acts as a placeholder.
 * An external entity (either an extender or a composer) is responsible for providing the values.
 */
export const referencablePropType_Abstract = 'abstract';
/**
 * A specialized form of abstract. The value must be set by an entity that uses this one as a property value.
 * It cannot be assigned by the declaring entity or by extenders.
 */
export const referencablePropType_Compose = 'compose';
/**
 * The value must be fully defined within the entity that declares this property.
 * It cannot be set or modified from outside, unless defined as inherited
 */
export const referencablePropType_Internal = 'internal';
export const referencablePropTypes = [referencablePropType_Inherit,
    referencablePropType_Abstract,
    referencablePropType_Compose,
    referencablePropType_Internal];
//# sourceMappingURL=types.js.map